<div class="modal-header">
    <h4 class="modal-title w-100 text-center fw-bold mb-0">
        {{ title() }}
        @if (subtitle()) {
            <span class="d-block fw-normal fs-6 text-secondary">{{ subtitle() }}</span>
        }
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
</div>

<div class="modal-body overflow-x-hidden entity-comparison-modal__body">
    <div class="entity-comparison-modal__filters">
        <adaa-entity-comparison-filters
            [showEntityTypeAndSize]="showEntityTypeAndSize()"
            [selectedPeriod]="selectedPeriod()"
            (filterChanged)="onFilterChanged($event)"
            (entitySizes)="entitySizes.set($event)"
            (entityTypes)="entityTypes.set($event)"
        />
    </div>

    @if (hasData()) {
        <div class="entity-comparison-modal__content">
            <adaa-chart-action-buttons
                [elementId]="elementId()"
                exportMode="element"
                [enableDownloadCSV]="enableDownloadCSV()"
                [csvRows]="csvRows()"
                [csvRowHeaders]="csvRowHeaders()"
            />

            <div [id]="elementId()" class="entity-comparison-modal__panel">
                <adaa-entity-performance-ranking [entities]="entities()" [average]="average()" />
            </div>
        </div>
    }
</div>
